import {
  useV2ListServicesForAccountQuery,
  useV2ListGovernancesForAccountQuery,
  useV2ListProductsForAccountQuery,
} from "@generated";
import type { ItemOption } from "../types";

export const useItemPickers = () => {
  // `include`/`page` are passed through paramsSerializer even if not in the typed arg.
  const { data: sData } = useV2ListServicesForAccountQuery(
    { include: ["service-category"], page: { size: 500 } } as any,
    { refetchOnMountOrArgChange: true }
  );
  const { data: gData } = useV2ListGovernancesForAccountQuery(
    { page: { size: 500 } } as any,
    { refetchOnMountOrArgChange: true }
  );
  const { data: pData } = useV2ListProductsForAccountQuery(
    { page: { size: 500 } } as any,
    { refetchOnMountOrArgChange: true }
  );

  const included = (sData as any)?.included ?? [];
  const nestedName = (relId?: string): string => {
    const cat = included.find(
      (i: any) =>
        i.type === "service-categories" && String(i.id) === String(relId)
    );
    return cat?.attributes?.["nested-name"] ?? "";
  };

  const services: ItemOption[] = (sData?.data ?? []).map((s: any) => {
    const name = s.attributes?.name ?? "";
    const catId = s.relationships?.["service-category"]?.data?.id;
    const cat = catId != null ? nestedName(catId) : "";
    return { id: String(s.id), name, label: cat ? `${name} (${cat})` : name };
  });
  const plain = (rows: any[]): ItemOption[] =>
    rows.map((x: any) => ({
      id: String(x.id),
      name: x.attributes?.name ?? "",
      label: x.attributes?.name ?? "",
    }));

  return {
    services,
    governances: plain(gData?.data ?? []),
    products: plain(pData?.data ?? []),
  };
};

export default useItemPickers;
